



// 



import { Component, ChangeDetectorRef } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { Whitelabel } from '../../models/whitelabel.model';
import { ApiService } from '../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { CreateEditWhitelabelModalComponent } from './create-edit-whitelabel-modal/create-edit-whitelabel-modal.component';
import { Router } from '@angular/router';
import { WhitelabelConfigsComponent } from './whitelabel-configs/whitelabel-configs.component';
import * as _ from 'lodash';
import { WhitelabelFeature } from '../../models/whitelabel-feature.model';


@Component({
    selector: 'whitelabels',
    template: require('./whitelabels.component.html'),
    styles: [require('./whitelabels.component.css')],
    animations: [fadeInOut]
})
export class WhitelabelsComponent {
    whitelabels: Whitelabel[];
    whitelabelFeatures: Array<WhitelabelFeature>;
    filter = '';

    /** Card chip being dragged, the row it belongs to, and the chip it is over; null when idle. */
    dragRow: any = null;
    dragConfig: any = null;
    dropConfig: any = null;
    /** whitelabelId of the site whose order is being saved, so its chips hold still. */
    savingOrderFor: number = null;

    /** Matches the site url, the product id, or any enabled feature's name. */
    get visibleWhitelabels(): any[] {
        const rows: any[] = this.whitelabels || [];
        const q = (this.filter || '').trim().toLowerCase();
        if (!q) { return rows; }

        return _.filter(rows, (w: any) =>
            (w.siteUrl || '').toLowerCase().indexOf(q) > -1 ||
            String(w.productId || '').indexOf(q) > -1 ||
            _.some(w.enableLabels || [], (l: any) =>
                (l.whitelabelFeature && l.whitelabelFeature.featureName || '').toLowerCase().indexOf(q) > -1));
    }

    constructor(private changeRef: ChangeDetectorRef, private router: Router, private apiService: ApiService, public dialog: MatDialog, private alertService: AlertService) {
        this.getWhitelabelFeatures();
        this.getWhitelabels();
    }

    /**
     * Reloads the list. Rows are merged into the objects already on screen so *ngFor
     * (with trackBy) leaves untouched rows alone instead of rebuilding the whole table.
     * Pass refreshFeatures = false when only the site fields can have changed.
     */
    getWhitelabels(refreshFeatures = true) {
        this.apiService.getWhitelabels().subscribe(r => {
            this.whitelabels = this.mergeWhitelabels(r);
            this.whitelabels.forEach((w: any) => {
                // Rows we've never seen always need their chips; the rest only on a full refresh.
                if (refreshFeatures || !w.enableLabels) {
                    this.getEnableWhiteLableFeatures(w);
                }
            });
        })
    }

    /** Keeps the existing row instance for a known whitelabelId and only patches its fields. */
    private mergeWhitelabels(incoming: Whitelabel[]): Whitelabel[] {
        const existingById = _.keyBy(this.whitelabels || [], 'whitelabelId');

        return _.map(incoming || [], (fresh: any) => {
            const existing: any = existingById[fresh.whitelabelId];
            if (!existing) { return fresh; }

            // enableLabels is loaded separately - don't wipe the chips already rendered.
            _.assign(existing, _.omit(fresh, 'enableLabels'));
            return existing;
        });
    }

    trackByWhitelabelId(index: number, row: any) {
        return row.whitelabelId;
    }

    trackByFeatureId(index: number, config: any) {
        return config.whitelabelFeatureId;
    }


    editWhitelabelConfigsWithSpecific(whitelabel, whitelabelFeatureSelected) {
        console.log(whitelabel, whitelabelFeatureSelected)
        let dialogRef = this.dialog.open(WhitelabelConfigsComponent, {
            panelClass: 'col-md-12',
            data: {
                whitelabel: whitelabel,
                //vendors: this.whitelabels
                whitelabelFeature: whitelabelFeatureSelected,
                whitelabelFeatures: this.whitelabelFeatures
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            // Configs only belong to this site - refresh its chips, leave the other rows alone.
            this.getEnableWhiteLableFeatures(whitelabel);
        })
    }

    createEditWhitelabel(whitelabel: any) {
        let dialogRef = this.dialog.open(CreateEditWhitelabelModalComponent, {
            width: '600px',
            data: {
                currentWhitelabel: whitelabel || {},
                //vendors: this.whitelabels
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            // The modal only edits the site fields, so skip the per-row feature reload.
            this.getWhitelabels(false);
        })
    }

    editWhitelabelConfigs(whitelabel: Whitelabel) {
        let dialogRef = this.dialog.open(WhitelabelConfigsComponent, {
            panelClass: 'col-md-12',
            data: {
                whitelabel: whitelabel,
                //vendors: this.whitelabels,
                whitelabelFeatures: this.whitelabelFeatures

            }
        });

        dialogRef.afterClosed().subscribe(r => {
            this.getEnableWhiteLableFeatures(whitelabel);
        })
    }

    getEnableWhiteLableFeatures(whiteLabel: Whitelabel) {
        this.apiService.getWhitelabelConfigs(whiteLabel.whitelabelId).subscribe(r => {
            var whitelabelConfigs = r || [];
            _.each(whitelabelConfigs, f => {
                f.whitelabelFeature.defaultSettingsObj = JSON.parse(f.whitelabelFeature.defaultSettings);
                try {
                    f.featureSettingsObj = f.featureSettings ? JSON.parse(f.featureSettings) : {};
                } catch (e) {
                    f.featureSettingsObj = {};
                }
            })

            // Chips read in the order the portal shows the cards: site-wide features first,
            // then the cards by this site's own position.
            whitelabelConfigs = _.sortBy(whitelabelConfigs, [
                (c: any) => this.isCard(c) ? 1 : 0,
                (c: any) => this.isCard(c) ? this.siteOrder(c) : 0,
                (c: any) => (c.whitelabelFeature.featureName || '').toLowerCase()
            ]);

            // Only swap the array when the chips actually differ, otherwise the row re-renders for nothing.
            if (this.featureChipsKey(whiteLabel.enableLabels) !== this.featureChipsKey(whitelabelConfigs)) {
                whiteLabel.enableLabels = whitelabelConfigs;
            }
        })
    }

    private featureChipsKey(configs: any[]): string {
        return _.map(configs || [], (c: any) => {
            const f = c.whitelabelFeature || {};
            const settings = f.defaultSettingsObj || {};
            return [c.whitelabelFeatureId, f.featureName, settings.icon, this.hasCustomOrder(c)].join('~');
        }).join('|');
    }

    /** Only benefits that render as a card have a position; the rest aren't tiles. */
    isCard(config: any): boolean {
        const d = config.whitelabelFeature && config.whitelabelFeature.defaultSettingsObj;
        return !!(d && d.buttonFunction);
    }

    /**
     * Where this site shows the card: sortOrder first, then the older index, falling back
     * to the default order. Coerced because the raw settings editor writes values as text.
     */
    private siteOrder(config: any): number {
        const pick = (o: any) => {
            if (!o) { return NaN; }
            const v = o.sortOrder === null || o.sortOrder === undefined || o.sortOrder === '' ? o.index : o.sortOrder;
            return v === null || v === undefined || v === '' ? NaN : Number(v);
        };
        let position = pick(config.featureSettingsObj);
        if (isNaN(position)) { position = pick(config.whitelabelFeature.defaultSettingsObj); }
        return isNaN(position) ? 999999 : position;
    }

    hasCustomOrder(config: any): boolean {
        return !!(config.featureSettingsObj && config.featureSettingsObj.sortOrderCustom);
    }

    rowHasCustomOrder(row: any): boolean {
        return _.some(row.enableLabels || [], (c: any) => this.hasCustomOrder(c));
    }

    canDrag(config: any): boolean {
        return this.isCard(config) && this.savingOrderFor === null;
    }

    onChipDragStart(event: any, row: any, config: any) {
        if (!this.canDrag(config)) { event.preventDefault(); return; }

        this.dragRow = row;
        this.dragConfig = config;

        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            // Firefox will not start a drag unless something is on the transfer.
            event.dataTransfer.setData('text/plain', String(config.whitelabelFeatureId));
        }
    }

    /** Cards only move among the same site's cards. */
    onChipDragOver(event: any, row: any, config: any) {
        if (!this.dragConfig || this.dragRow !== row || !this.isCard(config)) { return; }

        // Without this the browser rejects the drop.
        event.preventDefault();
        if (event.dataTransfer) { event.dataTransfer.dropEffect = 'move'; }
        this.dropConfig = config;
    }

    onChipDrop(event: any, row: any, config: any) {
        event.preventDefault();

        const moving = this.dragConfig;
        const sameRow = this.dragRow === row;
        this.clearChipDrag();

        if (!moving || !sameRow || moving === config || !this.isCard(config)) { return; }

        const previous: any[] = row.enableLabels;
        const labels = previous.slice();
        const to = labels.indexOf(config);
        labels.splice(labels.indexOf(moving), 1);
        labels.splice(to, 0, moving);

        row.enableLabels = labels;
        this.saveSiteOrder(row, previous);
    }

    onChipDragEnd() {
        this.clearChipDrag();
    }

    /** Which side of the hovered chip the dragged one would land on, or null. */
    dropSide(row: any, config: any): string {
        if (this.dropConfig !== config || this.dragRow !== row || this.dragConfig === config) { return null; }
        const labels = row.enableLabels || [];
        return labels.indexOf(this.dragConfig) > labels.indexOf(config) ? 'before' : 'after';
    }

    private clearChipDrag() {
        this.dragRow = null;
        this.dragConfig = null;
        this.dropConfig = null;
    }

    /**
     * Saved on drop. Writes only this site's copies and flags them, so a later re-order
     * in Benefit Contents leaves this plan alone. On failure the chips go back.
     */
    private saveSiteOrder(row: any, previous: any[]) {
        const cards = _.filter(row.enableLabels, (c: any) => this.isCard(c));
        const ids = _.map(cards, (c: any) => c.whitelabelFeatureId);

        this.savingOrderFor = row.whitelabelId;

        this.apiService.saveSiteOrder(row.whitelabelId, ids).subscribe((r: any) => {
            this.savingOrderFor = null;

            _.each(cards, (c: any, i: number) => {
                c.featureSettingsObj = c.featureSettingsObj || {};
                c.featureSettingsObj.sortOrder = i;
                c.featureSettingsObj.index = i;
                c.featureSettingsObj.sortOrderCustom = true;
            });

            if (r && r.unreadable && r.unreadable.length) {
                this.alertService.showMessage("",
                    "Order saved, but " + r.unreadable.length + " benefit(s) on this site have settings " +
                    "that are not valid JSON and kept their old position.", MessageSeverity.warn);
                this.getEnableWhiteLableFeatures(row);
            }
        }, () => {
            this.savingOrderFor = null;
            row.enableLabels = previous;
            this.alertService.showMessage("", "The new order could not be saved.", MessageSeverity.error);
        });
    }

    resetSiteOrder(row: any) {
        this.savingOrderFor = row.whitelabelId;
        this.apiService.resetSiteOrder(row.whitelabelId).subscribe(() => {
            this.savingOrderFor = null;
            this.getEnableWhiteLableFeatures(row);
        }, () => {
            this.savingOrderFor = null;
            this.alertService.showMessage("", "The order could not be reset.", MessageSeverity.error);
        });
    }

    getWhitelabelConfigs(whitelabelId) {
        this.apiService.getWhitelabelConfigs(whitelabelId).subscribe(r => {
            var whitelabelConfigs = r;
            console.log(r)
            this.changeRef.detectChanges();
        })
    }

    getWhitelabelFeatures() {
        this.apiService.getWhitelabelFeatures().subscribe(r => {
            this.whitelabelFeatures = r;
            _.each(this.whitelabelFeatures, f => {
                try {
                    f.defaultSettingsObj = JSON.parse(f.defaultSettings);
                } catch{
                    console.log(f)
                }
            })
            //console.log(this.whitelabelFeatures)
        })
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/whitelabels/whitelabels.component.ts